'use client';

import { c as _c } from "react/compiler-runtime";
import SuspenseWrapper from './_component/ui/common/SuspenseWrapper/SuspenseWrapper';
import { useGetDealType } from './_stores/useDealTypeStore';
import { ModalManager } from './ModalManager';
export default function Wrapper(t0) {
  const $ = _c(6);
  const {
    children
  } = t0;
  const dealType = useGetDealType();
  let t1;
  if ($[0] !== children) {
    t1 = <div id="container"><div id="inner">{children}</div></div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SuspenseWrapper fallback={null}><ModalManager /></SuspenseWrapper>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== dealType || $[4] !== t1) {
    t3 = <div id="wrap" data-deal-type={dealType}>{t1}{t2}</div>;
    $[3] = dealType;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}